import firebase from "firebase";
  
const firebaseConfig = {
  apiKey: "AIzaSyD7CDhpm47ucPEsXweWDYlQrnznhLR55WE",
  authDomain: "react-portfolio-a656d.firebaseapp.com",
  projectId: "react-portfolio-a656d",
  storageBucket: "react-portfolio-a656d.appspot.com",
  messagingSenderId: "1003308892509",
  appId: "1:1003308892509:web:fc7665b33a15d2633168b4",
  measurementId: "G-SR2PPSM8H9"
};
  
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
  
export default db;